const getValue = (array, key) => {
  const item = array?.find((item) => item.key === key);
  return item;
};

export default getValue;
